"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTheme = exports.popStackTheme = exports.popTeamsTheme = exports.popStudyTheme = exports.popQuizTheme = void 0;
const material_1 = require("@mui/material");
const poptheme = (0, material_1.createTheme)({
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                    textTransform: 'none',
                    '&:hover': {
                        boxShadow: 'none',
                    },
                    variants: [
                        {
                            props: { variant: 'capsuleContained' },
                            style: ({ theme, ownerState, }) => {
                                var _a, _b, _c;
                                return ({
                                    fontSize: ownerState.size === 'small'
                                        ? '0.8125rem'
                                        : ownerState.size === 'medium'
                                            ? '0.875rem'
                                            : '0.9375rem',
                                    borderRadius: '624.9375rem',
                                    backgroundColor: ((_a = theme.palette[ownerState.color]) === null || _a === void 0 ? void 0 : _a.main) ||
                                        theme.palette.primary.main, // Use color prop
                                    color: ((_b = theme.palette[ownerState.color]) === null || _b === void 0 ? void 0 : _b.contrastText) ||
                                        theme.palette.primary.contrastText, // Use contrast text color
                                    padding: ownerState.size === 'small'
                                        ? '0.25rem, 0.63rem'
                                        : ownerState.size === 'medium'
                                            ? '0.38rem 1rem'
                                            : '0.5rem 1.38rem',
                                    '&:hover': {
                                        backgroundColor: ((_c = theme.palette[ownerState.color]) === null || _c === void 0 ? void 0 : _c.dark) ||
                                            theme.palette.primary.dark, // Use dark color for hover
                                    },
                                });
                            },
                        },
                        {
                            props: { variant: 'capsuleOutlined' },
                            style: ({ theme, ownerState, }) => {
                                var _a, _b, _c;
                                return ({
                                    fontSize: ownerState.size === 'small'
                                        ? '0.8125rem'
                                        : ownerState.size === 'medium'
                                            ? '0.875rem'
                                            : '0.9375rem',
                                    borderRadius: '624.9375rem',
                                    borderColor: (0, material_1.alpha)(((_a = theme.palette[ownerState.color]) === null || _a === void 0 ? void 0 : _a.main) ||
                                        theme.palette.primary.main, 0.5),
                                    border: '1px solid',
                                    color: ((_b = theme.palette[ownerState.color]) === null || _b === void 0 ? void 0 : _b.main) ||
                                        theme.palette.primary.main, // Use color prop
                                    padding: ownerState.size === 'small'
                                        ? '0.25rem, 0.63rem'
                                        : ownerState.size === 'medium'
                                            ? '0.38rem 1rem'
                                            : '0.5rem 1.38rem',
                                    '&:hover': {
                                        backgroundColor: (0, material_1.alpha)(((_c = theme.palette[ownerState.color]) === null || _c === void 0 ? void 0 : _c.main) ||
                                            theme.palette.primary.main, 0.04),
                                    },
                                });
                            },
                        },
                    ],
                },
            },
        },
    },
});
exports.popQuizTheme = (0, material_1.createTheme)(poptheme, {
    palette: {
        mode: 'light',
        primary: {
            main: '#7451EA',
            light: '#9E85F0',
            dark: '#6140E4',
        },
    },
});
exports.popStudyTheme = (0, material_1.createTheme)(poptheme, {
    palette: {
        mode: 'light',
        primary: {
            main: '#4A69F0',
            light: '#8096F5',
            dark: '#3A56EC',
        },
    },
});
exports.popTeamsTheme = (0, material_1.createTheme)(poptheme, {
    palette: {
        mode: 'light',
        primary: {
            main: '#0E8484',
            light: '#56A9A9',
            dark: '#0A7171',
        },
    },
});
exports.popStackTheme = (0, material_1.createTheme)(poptheme, {
    palette: {
        mode: 'light',
        primary: {
            main: '#AEB0B9',
            light: '#E4E5E8',
            dark: '#878A97',
        },
    },
});
function getTheme(appTheme) {
    switch (appTheme) {
        case 'PopStudy':
            return exports.popStudyTheme;
        case 'PopQuiz':
            return exports.popQuizTheme;
        case 'PopTeams':
            return exports.popTeamsTheme;
        case 'PopStack':
            return exports.popStackTheme;
    }
}
exports.getTheme = getTheme;
